export enum FeatureCodeEnum {
  ADMIN_USER_LIST = 'ADMIN_USER_LIST',
  FETCH_ACTIVITY_TYPE = 'FETCH_ACTIVITY_TYPE',
  ACTIVITY_LOG = 'ACTIVITY_LOG',
  ADD_ADMIN_USER = 'ADD_ADMIN_USER',
  EDIT_ADMIN_USER = 'EDIT_ADMIN_USER',
  FETCH_ADMIN_USER = 'FETCH_ADMIN_USER',
  DELETE_ADMIN_USER = 'DELETE_ADMIN_USER',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET',
  FETCH_LOGGED_IN_USER_DETAILS = 'FETCH_LOGGED_IN_USER_DETAILS',
  ADD_ROLE = 'ADD_ROLE',
  EDIT_ROLE = 'EDIT_ROLE',
  FETCH_ROLE_LIST = 'FETCH_ROLE_LIST',
  FETCH_ROLE_LIST_FILTER = 'FETCH_ROLE_LIST_FILTER',
  FETCH_ROLE = 'FETCH_ROLE',
  DELETE_ROLE = 'DELETE_ROLE',
  ADD_APP_SETTINGS = 'ADD_APP_SETTINGS',
  EDIT_APP_SETTINGS = 'EDIT_APP_SETTINGS',
  ADD_BANK_BRANCH = 'ADD_BANK_BRANCH',
  UPDATE_OTHER_BANK_BRANCH = 'UPDATE_OTHER_BANK_BRANCH',
  EDIT_BANK_INFO = 'EDIT_BANK_INFO',
  EDIT_BRANCH_INFO = 'EDIT_BRANCH_INFO',
  ADD_BILLING_INTEGRATION = 'ADD_BILLING_INTEGRATION',
  ADD_BILLER_FEATURE = 'ADD_BILLER_FEATURE',
  EDIT_BILLER_FEATURE = 'EDIT_BILLER_FEATURE',
  ADD_BILLER_CATEGORY = 'ADD_BILLER_CATEGORY',
  EDIT_BILLER_CATEGORY = 'EDIT_BILLER_CATEGORY',
  ADD_CHARGE_CONFIG = 'ADD_CHARGE_CONFIG',
  EDIT_CHARGE_CONFIG = 'EDIT_CHARGE_CONFIG',
  ADD_LIMIT_CONFIG = 'ADD_LIMIT_CONFIG',
  EDIT_LIMIT_CONFIG = 'EDIT_LIMIT_CONFIG',
  ADD_TRANSACTION_CATEGORY = 'ADD_TRANSACTION_CATEGORY',
  EDIT_TRANSACTION_CATEGORY = 'EDIT_TRANSACTION_CATEGORY',
  ADD_TRANSACTION_FEATURE = 'ADD_TRANSACTION_FEATURE',
  EDIT_TRANSACTION_FEATURE = 'EDIT_TRANSACTION_FEATURE',
  ADD_OFFER = 'ADD_OFFER',
  EDIT_OFFER = 'EDIT_OFFER',
  ADD_PROMOTIONAL_BANNER = 'ADD_PROMOTIONAL_BANNER',
  EDIT_PROMOTIONAL_BANNER = 'EDIT_PROMOTIONAL_BANNER',
  ADD_TRANSACTION_PURPOSE = 'ADD_TRANSACTION_PURPOSE',
  EDIT_TRANSACTION_PURPOSE = 'EDIT_TRANSACTION_PURPOSE',
  ADD_LANGUAGE = 'ADD_LANGUAGE',
  EDIT_LANGUAGE = 'EDIT_LANGUAGE',
  ADD_TRANSACTION_CONFIG_SELECTOR = 'ADD_TRANSACTION_CONFIG_SELECTOR',
  EDIT_TRANSACTION_CONFIG_SELECTOR = 'EDIT_TRANSACTION_CONFIG_SELECTOR',
  ADD_TRANSACTION_MONTHLY_CHARGE_SLAB = 'ADD_TRANSACTION_MONTHLY_CHARGE_SLAB',
  EDIT_TRANSACTION_MONTHLY_CHARGE_SLAB = 'EDIT_TRANSACTION_MONTHLY_CHARGE_SLAB',
  ADD_TRANSACTION_AMOUNT_CHARGE_SLAB = 'ADD_TRANSACTION_AMOUNT_CHARGE_SLAB',
  EDIT_TRANSACTION_AMOUNT_CHARGE_SLAB = 'EDIT_TRANSACTION_AMOUNT_CHARGE_SLAB',
  CREATE_MENU = 'CREATE_MENU',
  EDIT_MENU = 'EDIT_MENU',
  DELETE_MENU = 'DELETE_MENU',
  ADD_TERMS_CONDITION = 'ADD_TERMS_CONDITION',
  EDIT_TERMS_CONDITION = 'EDIT_TERMS_CONDITION',
  DELETE_TERMS_CONDITION = 'DELETE_TERMS_CONDITION',
  ADD_GROUP = 'ADD_GROUP',
  EDIT_GROUP = 'EDIT_GROUP',
  ADD_MERCHANT_GROUP = 'ADD_MERCHANT_GROUP',
  EDIT_MERCHANT_GROUP = 'EDIT_MERCHANT_GROUP',
  ADD_MERCHANT_RATE_CARD = 'ADD_MERCHANT_RATE_CARD',
  EDIT_MERCHANT_RATE_CARD = 'EDIT_MERCHANT_RATE_CARD',
  UPDATE_CUSTOMER_STATUS = 'UPDATE_CUSTOMER_STATUS',
  ADD_TFA_CONFIG = 'ADD_TFA_CONFIG',
  EDIT_TFA_CONFIG = 'EDIT_TFA_CONFIG',
  ADD_NOTIFICATION_TEMPLATE = 'ADD_NOTIFICATION_TEMPLATE',
  EDIT_NOTIFICATION_TEMPLATE = 'EDIT_NOTIFICATION_TEMPLATE',
  RECONCILIATION_APPROVE_REQUEST_AGGREGATOR = 'RECONCILIATION_APPROVE_REQUEST_AGGREGATOR',
  RECONCILIATION_APPROVE_REQUEST_MERCHANT = 'RECONCILIATION_APPROVE_REQUEST_MERCHANT',
  RECONCILIATION_APPROVE_REQUEST_TCS = 'RECONCILIATION_APPROVE_REQUEST_TCS',
  SETTLEMENT_APPROVE_REQUEST_MERCHANT = 'SETTLEMENT_APPROVE_REQUEST_MERCHANT',
  SETTLEMENT_APPROVE_REQUEST_AGGREGATOR = 'SETTLEMENT_APPROVE_REQUEST_AGGREGATOR',
  PAYOUT_APPROVE_REQUEST_MERCHANT = 'PAYOUT_APPROVE_REQUEST_MERCHANT',
  PAYOUT_APPROVE_REQUEST_AGGREGATOR = 'PAYOUT_APPROVE_REQUEST_AGGREGATOR',
  ADD_TOPUP_OFFER = 'ADD_TOPUP_OFFER',
  EDIT_TOPUP_OFFER = 'EDIT_TOPUP_OFFER',
  EDIT_REGISTERED_MERCHANT = 'EDIT_REGISTERED_MERCHANT',
  EDIT_BILLING_INTEGRATION = 'EDIT_BILLING_INTEGRATION',
  CHANGE_CUSTOMER_GROUP = 'CHANGE_CUSTOMER_GROUP',
  ASSIGN_CUSTOMER_GROUP_FEATURES = 'ASSIGN_CUSTOMER_GROUP_FEATURES',
  ASSIGN_MERCHANT_GROUP_FEATURES = 'ASSIGN_MERCHANT_GROUP_FEATURES',
  ASSIGN_MERCHANT_GROUP_MENUS = 'ASSIGN_MERCHANT_GROUP_MENUS',
  ADD_CUSTOMER = 'ADD_CUSTOMER',
  CREATE_MERCHANT_ADMIN = 'CREATE_MERCHANT_ADMIN',
  EDIT_MERCHANT_ADMIN = 'EDIT_MERCHANT_ADMIN',
  ADD_AGGREGATOR = 'ADD_AGGREGATOR',
  EDIT_AGGREGATOR = 'EDIT_AGGREGATOR',
  INITIATE_EMONEY_REQUEST = 'INITIATE_EMONEY_REQUEST',
  UPDATE_EMONEY_REQUEST = 'UPDATE_EMONEY_REQUEST',
  CREATE_JOURNAL_ENTRY = 'CREATE_JOURNAL_ENTRY',
  EXECUTE_MONTH_CLOSING = 'EXECUTE_MONTH_CLOSING',
  ADD_GL_ACCOUNT = 'ADD_GL_ACCOUNT',
  EDIT_GL_ACCOUNT = 'EDIT_GL_ACCOUNT',
  ADD_MERCHANT_DOCUMENTS = 'ADD_MERCHANT_DOCUMENTS',
  ADD_COG_CONFIG = 'ADD_COG_CONFIG',
  EDIT_COG_CONFIG = 'EDIT_COG_CONFIG',
  ADD_COG_SCHEDULE = 'ADD_COG_SCHEDULE',
  EDIT_SCHEDULER = 'EDIT_SCHEDULER',
  DELETE_SCHEDULE = 'DELETE_SCHEDULE',
  DELETE_CONFIG = 'DELETE_CONFIG',
  ADD_BUSINESS_TYPE = 'ADD_BUSINESS_TYPE',
  EDIT_BUSINESS_TYPE = 'EDIT_BUSINESS_TYPE',
  ADD_COUNTER = 'ADD_COUNTER',
  CREATE_EVENT = 'CREATE_EVENT',
  CREATE_PARTNER = 'CREATE_PARTNER',
  EDIT_EVENT = 'EDIT_EVENT',
  ADD_MERCHANT_TYPE = 'ADD_MERCHANT_TYPE',
  EDIT_MERCHANT_TYPE = 'EDIT_MERCHANT_TYPE',
  EDIT_COUNTER = 'EDIT_COUNTER',
  COUNTER_PASSWORD_CHANGE = 'COUNTER_PASSWORD_CHANGE',
  ADD_MERCHANT_BANK_ACCOUNT = 'ADD_MERCHANT_BANK_ACCOUNT',
  EDIT_MERCHANT_BANK_ACCOUNT = 'EDIT_MERCHANT_BANK_ACCOUNT',
  UPDATE_OWN_BANK_BRANCH = 'UPDATE_OWN_BANK_BRANCH',
  UPDATE_FEATURE_BY_GROUP = 'UPDATE_FEATURE_BY_GROUP',
  CREATE_MERCHANT = 'CREATE_MERCHANT',
  EDIT_MERCHANT = 'EDIT_MERCHANT',
  CREATE_LIVE_KEY = 'CREATE_LIVE_KEY',
  UPDATE_WEBHOOK_API = 'UPDATE_WEBHOOK_API',
  ADD_PROFILE_LIMIT = 'ADD_PROFILE_LIMIT',
  UPDATE_PROFILE_LIMIT = 'UPDATE_PROFILE_LIMIT',
  ASSIGN_PROFILE_TO_USER = 'ASSIGN_PROFILE_TO_USER',
  REMOVE_PROFILE_FROM_USER = 'REMOVE_PROFILE_FROM_USER',
  ADD_SYSTEM_NOTICE = 'ADD_SYSTEM_NOTICE',
  EDIT_SYSTEM_NOTICE = 'EDIT_SYSTEM_NOTICE',
  CREATE_BULK_PUSH_NOTIFICATION = 'CREATE_BULK_PUSH_NOTIFICATION',
  SERVICE_REQUEST_STATUS_UPDATE = 'SERVICE_REQUEST_STATUS_UPDATE',
  UPDATE_PAYMENT_CONFIG = 'UPDATE_PAYMENT_CONFIG',
  UPDATE_CUSTOMER_EMAIL = 'UPDATE_CUSTOMER_EMAIL',
  ADD_BRANCH_LOCATION = 'ADD_BRANCH_LOCATION',
  UPDATE_BRANCH_LOCATION = 'UPDATE_BRANCH_LOCATION',
  REMOVE_BRANCH_LOCATION = 'REMOVE_BRANCH_LOCATION',
  ADD_ATM_LOCATION = 'ADD_ATM_LOCATION',
  UPDATE_ATM_LOCATION = 'UPDATE_ATM_LOCATION',
  REMOVE_ATM_LOCATION = 'REMOVE_ATM_LOCATION',
  UNTAG_CREDIT_CARD = 'UNTAG_CREDIT_CARD',
  CREATE_BULK_NOTIFICATION = 'CREATE_BULK_NOTIFICATION',
  UPLOAD_BULK_BRANCH = 'UPLOAD_BULK_BRANCH',
  UPLOAD_BULK_BANK = 'UPLOAD_BULK_BANK',
  BILLER_CONFIGURATION = 'BILLER_CONFIGURATION',
  CREATE_NOTIFICATION_CUSTOMER_GROUP = 'CREATE_NOTIFICATION_CUSTOMER_GROUP',
  UPDATE_NOTIFICATION_CUSTOMER_GROUP = 'UPDATE_NOTIFICATION_CUSTOMER_GROUP',
  DELETE_NOTIFICATION_CUSTOMER_GROUP = 'DELETE_NOTIFICATION_CUSTOMER_GROUP',
  DELETE_NOTIFICATION_CUSTOMER_GROUP_USER = 'DELETE_NOTIFICATION_CUSTOMER_GROUP_USER',
  CREATE_FDR_DPS_PRODUCT_TYPE = 'CREATE_FDR_DPS_PRODUCT_TYPE',
  UPDATE_FDR_DPS_PRODUCT_TYPE = 'UPDATE_FDR_DPS_PRODUCT_TYPE',
  CREATE_FDR_DPS_PRODUCT_TENOR = 'CREATE_FDR_DPS_PRODUCT_TENOR',
  UPDATE_FDR_DPS_PRODUCT_TENOR = 'UPDATE_FDR_DPS_PRODUCT_TENOR',
  DELETE_FDR_DPS_PRODUCT_TENOR = 'DELETE_FDR_DPS_PRODUCT_TENOR',
  BANK_ACCOUNT_OPENING_REQUEST_PROCESS = 'BANK_ACCOUNT_OPENING_REQUEST_PROCESS',
}
